import React from 'react'
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import CarFilterConnections from './CarFilterConnections';
import Orders from './Orders';
import Order from './Order';
import Customers from './Customers';
import Products from './Products';
import Coupons from './Coupons';
import BlogsManagement from './BlogsManagement';
import Popups from './Popups';

function WrongPage() {
  const location = useLocation();
  const navigate = useNavigate();


  const tiles = [
    { id: 1, name: 'Порачки', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Orders_uus35w.jpg', link: '/wrongPage/orders' },
    { id: 2, name: 'Корисници', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Users_jzihfn.png', link: '/wrongPage/customers' },
    { id: 3, name: 'Поврзување на продукти со автомобили', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Connections_fycrkw.jpg', link: '/wrongPage/carFilterConnections' },
    { id: 4, name: 'Продукти', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541522/Products_ujgzjt.jpg', link: '/wrongPage/products' },
    { id: 5, name: 'Купони', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Coupons_w5xeax.jpg', link: '/wrongPage/coupons' },
    { id: 6, name: 'Блог', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Coupons_w5xeax.jpg', link: '/wrongPage/blogsManagement' },
    { id: 7, name: 'Модал', img: 'https://res.cloudinary.com/dxftga19f/image/upload/v1739541521/Coupons_w5xeax.jpg', link: '/wrongPage/popups' }
  ]

  const logOut = () => {
    localStorage.removeItem('authToken')
    navigate('/')
  }

  return (
    <div>
      <div className='w-full flex'>
        <p className='underline text-blue-400 cursor-pointer ml-auto' onClick={() => logOut()}>Одјави се</p>
      </div>
      <h1 className='text-5xl text-center mb-12 text-orange-500 font-bold'>Админ панел</h1>
      <nav>
        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-6 p-6">
          {tiles.map((item) => {
            const isActive = location.pathname === item.link;

            return (
              <Link to={item.link} key={item.id}>
                <div
                  className={`card w-full bg-base-100 shadow-xl
                hover:scale-105 hover:shadow-2xl transition-transform transform
                ${isActive ? 'bg-orange-500 text-white' : ''} 
                hover:bg-orange-100 hover:opacity-90`}
                >
                  <figure><img src={item.img} alt={`${item.name}`} /></figure>
                  <div className="card-body flex flex-col justify-center items-center text-center p-4">
                    <h2 className="card-title break-words">{item.name}</h2>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </nav>

      <Routes>
        <Route path="customers" element={<Customers />} />
        <Route path="carFilterConnections" element={<CarFilterConnections />} />
        <Route path="orders" element={<Orders />} />
        <Route path="order/id" element={<Order />} />
        <Route path="products" element={<Products />} />
        <Route path="coupons" element={<Coupons />} />
        <Route path="blogsManagement" element={<BlogsManagement />} />
        <Route path="popups" element={<Popups />} />
      </Routes>
    </div>
  )
}

export default WrongPage
